import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FILTER_CONTENT_ITEM, ISelectInput, SearchSelector } from '@portal/shared/ui/filter';
import { Products } from './product.list';
import { FilterStaticBase } from '@portal/shared/ui/filter/src/lib/components/static-base';
import { TransactionFilterList } from '../transaction-filters.list';
import { TransactionFilter } from '../../../enums/transaction-filter.enum';
import { FiltersService } from '@portal/shared/ui/filter/src/lib/services/filters.service';
import { SupportedProcessorSettingsService } from '@apps/portal/src/app/services/supported-processor-settings.service';
import cloneDeep from 'lodash/cloneDeep';
@Component({
  selector: 'portal-filter-product',
  templateUrl: './product.component.html',
  providers: [
    {
      provide: FILTER_CONTENT_ITEM,
      useExisting: FilterProductComponent,
    },
  ],
  standalone: false,
})
export class FilterProductComponent extends FilterStaticBase {
  @Input()
  isMainDropdownFilter: boolean;
  @Input() showFilterSubMenu: boolean;
  @Output()
  productTextName: EventEmitter<string> = new EventEmitter();
  productText = this.transactionfilters.list.find(
    (filter) => filter.id === TransactionFilter.Product,
  ).text;
  searchSelectorBrand: SearchSelector.Brand;
  productTypes: ISelectInput[];

  constructor(
    private products: Products,
    private transactionfilters: TransactionFilterList,
    private filtersService: FiltersService,
    private supportedProcessorSettingsService: SupportedProcessorSettingsService,
  ) {
    super(SearchSelector.Brand, products.getSupportedProduct());
    this.productTypes = cloneDeep(products.list);

    this.filtersService.actionRemoveFilter$.subscribe((entityToRemove: ISelectInput) => {
      if (SearchSelector.Brand === entityToRemove.key) {
        const selectedEntity = this.localPreSelectedEntities.get(entityToRemove.id);
        if (selectedEntity?.id) {
          this.onEntityRemoved(entityToRemove);
          this.onFilterApplied();
          this.itemToggled.emit();
        }
      }
    });

    this.supportedProcessorSettingsService.isProcessorFetched$.subscribe(() => {
      this.setAllEntities(products.getSupportedProduct());
    });

    this.subMenuComponentSelected$.subscribe((submenu) => {
      if (SearchSelector.Brand.includes(submenu)) {
        this.synchronizeLocalPreSelectedEntities();
      }
      this.updateEntities();
    });

    this.updateEntities$.subscribe(() => {
      if (this.isMainDropdownFilter) {
        this.synchronizeLocalPreSelectedEntities();
      }
      this.updateEntities();
    });

    this.updateCounter$.subscribe(() => {
      const localPreSelected: Map<string, ISelectInput> = new Map();
      if (this.criteriaMapPreSelected.has(SearchSelector.Brand)) {
        const argumentArr = this.getArgumentArray(
          this.criteriaMapPreSelected,
          SearchSelector.Brand,
        );

        if (this.criteriaMapPreSelected.get(SearchSelector.Brand)?.argument) {
          argumentArr?.forEach((argument) => {
            localPreSelected.set(argument, {
              id: argument,
              text: this.products.getValue(argument),
            });
          });
          this.localPreSelectedEntities = cloneDeep(localPreSelected);
        } else {
          this.localPreSelectedEntities.clear();
        }
      }
      this.updateEntities();
    });
  }

  onFilterAppliedAndEntitiesUpdated(): void {
    this.entities = this.products.getSupportedProduct();
    this.onFilterApplied();
    this.updateEntities();
    if (this.isOpen) {
      this.closeSubmenus$.next(true);
    }
    this.productTextName.emit(this.productText);
    this.isOpen = false;
  }

  private synchronizeLocalPreSelectedEntities(): void {
    if (this.criteriaMapPreSelected?.get(SearchSelector.Brand)?.argument) {
      const argumentArr = this.getArgumentArray(this.selectedEntities, SearchSelector.Brand);
      this.localPreSelectedEntities.clear();
      argumentArr.forEach((argument) => {
        this.setLocalPreSelectedEntities(argument, this.products.getValue(argument));
      });
    } else {
      this.localPreSelectedEntities.clear();
    }
    this.updateEntities();
  }
}
